/* eslint-disable */
export default {
  unknown: 'Desconhecido',
  multipleMatches: 'Várias correspondências',
  anonymous: 'Anónimo',
  none: 'Nenhuma',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
